export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-apps-2-line', color: 'primary' },
  { id: 'romance', name: '恋爱', slug: 'romance', icon: 'ri-heart-line', color: 'accent' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', color: 'accent' },
  { id: 'action', name: '动作', slug: 'action', icon: 'ri-fire-line', color: 'accent' },
  { id: 'thriller', name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line', color: 'accent' },
  { id: 'comedy', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { id: 'drama', name: '剧情', slug: 'drama', icon: 'ri-movie-line', color: 'accent' },
  { id: 'daily', name: '日常', slug: 'daily', icon: 'ri-sun-line', color: 'accent' },
  { id: 'horror', name: '恐怖', slug: 'horror', icon: 'ri-ghost-line', color: 'accent' },
  { id: 'bl', name: '耽美', slug: 'bl', icon: 'ri-user-heart-line', color: 'accent' },
];

export const comics = [
  {
    id: 1,
    title: '我的野蛮女友',
    author: '李智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20comic%2C%20young%20couple%20in%20modern%20Seoul%20city%20street%2C%20warm%20pink%20and%20peach%20tones%2C%20illustration%20style%20with%20soft%20lighting%2C%20clean%20composition%2C%20minimalist%20background&width=600&height=840&seq=comic-cover-01&orientation=portrait',
    category: 'romance',
    categoryName: '恋爱',
    rating: 9.5,
    views: 1250000,
    chapters: 86,
    status: '连载中',
    description: '一段发生在首尔街头的爆笑恋爱故事。平凡大学生金泰宇偶然邂逅性格火爆却内心温柔的她，从此人生发生了翻天覆地的变化。两人之间的搞笑日常和甜蜜互动，让人笑中带泪。',
    tags: ['恋爱', '搞笑', '校园', '日常'],
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 2,
    title: '剑之领主',
    author: '朴成俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20fantasy%20action%20comic%2C%20warrior%20with%20magical%20sword%20in%20dark%20fantasy%20world%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20illustration%20style%20with%20rich%20details%2C%20golden%20and%20crimson%20accents&width=600&height=840&seq=comic-cover-02&orientation=portrait',
    category: 'fantasy',
    categoryName: '奇幻',
    rating: 9.7,
    views: 2380000,
    chapters: 124,
    status: '连载中',
    description: '在剑与魔法的世界里，一个被遗弃的少年意外觉醒了传说中的剑之血脉。为了寻找真相，他踏上了成为最强剑士的征途。宏大的世界观，扣人心弦的战斗场面，不容错过的奇幻史诗。',
    tags: ['奇幻', '动作', '冒险', '热血'],
    updatedAt: '2026-08-03',
    featured: true,
  },
  {
    id: 3,
    title: '秘密森林',
    author: '金秀贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20mystery%20and%20suspense%2C%20dark%20forest%20with%20moonlight%2C%20silhouette%20of%20two%20figures%2C%20atmospheric%20and%20tense%2C%20cool%20green%20and%20navy%20tones%2C%20illustration%20style%2C%20clean%20composition&width=600&height=840&seq=comic-cover-03&orientation=portrait',
    category: 'thriller',
    categoryName: '悬疑',
    rating: 9.6,
    views: 1870000,
    chapters: 72,
    status: '连载中',
    description: '一桩离奇的连环失踪案将检察官韩志勋卷入了一个巨大的阴谋之中。他在追查真相的过程中发现，所有的线索都指向了那片被称为"秘密森林"的禁区。紧张刺激的悬疑大片，每章都让人屏息凝神。',
    tags: ['悬疑', '推理', '犯罪', '剧情'],
    updatedAt: '2026-08-02',
    featured: true,
  },
  {
    id: 4,
    title: '甜美陷阱',
    author: '崔智友',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20sweet%20love%20story%2C%20beautiful%20woman%20and%20handsome%20man%20in%20cafe%2C%20soft%20pastel%20pink%20and%20cream%20tones%2C%20warm%20ambient%20lighting%2C%20illustration%20style%2C%20romantic%20atmosphere&width=600&height=840&seq=comic-cover-04&orientation=portrait',
    category: 'romance',
    categoryName: '恋爱',
    rating: 9.3,
    views: 980000,
    chapters: 56,
    status: '连载中',
    description: '甜点师林多美在一家高级酒店工作，偶然与酒店继承人朴志勋相识。原本以为是一场甜蜜的邂逅，却发现背后隐藏着家族恩怨的秘密。当爱情与阴谋交织，她该如何抉择？',
    tags: ['恋爱', '剧情', '都市', '美食'],
    updatedAt: '2026-08-01',
    featured: false,
  },
  {
    id: 5,
    title: '热血高校',
    author: '郑宇成',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20high%20school%20fighting%20comic%2C%20strong%20male%20protagonist%20in%20school%20uniform%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20orange%20tones%2C%20illustration%20style%2C%20energetic%20composition&width=600&height=840&seq=comic-cover-05&orientation=portrait',
    category: 'action',
    categoryName: '动作',
    rating: 9.4,
    views: 1560000,
    chapters: 98,
    status: '连载中',
    description: '以最强不良少年为目标的姜泰浩转学到了一所臭名昭著的高中。在这里，他将面对各路强敌，用拳头打出属于自己的传说。热血沸腾的校园格斗，友情与信念的碰撞！',
    tags: ['动作', '校园', '热血', '友情'],
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 6,
    title: '搞笑一家人',
    author: '刘在石',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20funny%20family%20daily%20life%2C%20cartoonish%20illustration%20style%2C%20four%20family%20members%20laughing%2C%20bright%20yellow%20and%20orange%20tones%2C%20clean%20simple%20composition%2C%20humorous%20expression&width=600&height=840&seq=comic-cover-06&orientation=portrait',
    category: 'comedy',
    categoryName: '搞笑',
    rating: 9.2,
    views: 2100000,
    chapters: 156,
    status: '连载中',
    description: '四个性格迥异的家庭成员每天都上演着令人捧腹的爆笑日常。爸爸的迷糊、妈妈的唠叨、哥哥的中二、妹妹的腹黑——这个家永远不会无聊！轻松解压必备神作。',
    tags: ['搞笑', '日常', '家庭', '生活'],
    updatedAt: '2026-08-03',
    featured: false,
  },
  {
    id: 7,
    title: '末日的尽头',
    author: '韩尚宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post-apocalyptic%20cover%20art%2C%20survival%20in%20ruined%20city%2C%20lone%20survivor%20with%20weapon%2C%20dark%20atmospheric%20grey%20and%20rust%20tones%2C%20dramatic%20composition%2C%20illustration%20style%2C%20desolate%20mood&width=600&height=840&seq=comic-cover-07&orientation=portrait',
    category: 'drama',
    categoryName: '剧情',
    rating: 9.8,
    views: 3200000,
    chapters: 110,
    status: '连载中',
    description: '突如其来的灾难毁灭了文明世界。幸存者们在这片废墟之上挣扎求生，人性的善与恶在末日面前暴露无遗。一部关于希望与绝望的史诗级生存故事，口碑炸裂！',
    tags: ['剧情', '末日', '生存', '人性'],
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 8,
    title: '咖啡与猫',
    author: '孙艺珍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20cozy%20cat%20cafe%2C%20young%20woman%20with%20cats%2C%20warm%20brown%20and%20cream%20tones%2C%20soft%20illustration%20style%2C%20peaceful%20atmosphere%2C%20clean%20minimalist%20composition&width=600&height=840&seq=comic-cover-08&orientation=portrait',
    category: 'daily',
    categoryName: '日常',
    rating: 9.1,
    views: 780000,
    chapters: 42,
    status: '连载中',
    description: '辞去大公司工作的韩素熙，在一条安静的小巷里开了一家猫咪咖啡馆。在这里，她遇到了各种各样的人和猫，每一段相遇都是一则温暖的小故事。治愈系日常，抚慰疲惫的心灵。',
    tags: ['日常', '治愈', '美食', '猫咪'],
    updatedAt: '2026-08-02',
    featured: false,
  },
  {
    id: 9,
    title: '暗夜追踪者',
    author: '金明洙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20thriller%20cover%20art%2C%20detective%20chasing%20shadow%20in%20dark%20alley%2C%20noir%20style%2C%20moody%20dark%20red%20and%20black%20tones%2C%20intense%20atmosphere%2C%20illustration%20style%2C%20suspenseful%20composition&width=600&height=840&seq=comic-cover-09&orientation=portrait',
    category: 'horror',
    categoryName: '恐怖',
    rating: 9.3,
    views: 1450000,
    chapters: 64,
    status: '连载中',
    description: '首尔夜晚的街头，一连串诡异的案件让整座城市陷入恐慌。刑警朴志浩在调查中发现，这些案件背后隐藏着一个超自然的存在。暗夜之中，谁才是真正的猎手？',
    tags: ['恐怖', '悬疑', '超自然', '刑侦'],
    updatedAt: '2026-08-01',
    featured: false,
  },
  {
    id: 10,
    title: '繁星之约',
    author: '郑多彬',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20cover%20art%2C%20two%20handsome%20young%20men%20under%20starry%20night%20sky%2C%20soft%20purple%20and%20silver%20tones%2C%20dreamy%20atmosphere%2C%20illustration%20style%2C%20emotional%20and%20tender%20composition&width=600&height=840&seq=comic-cover-10&orientation=portrait',
    category: 'bl',
    categoryName: '耽美',
    rating: 9.6,
    views: 1680000,
    chapters: 80,
    status: '连载中',
    description: '天文系学生尹星辰在某次观测中偶遇了神秘男子韩明月。从那以后，他们总在星空下不期而遇。两颗孤独的心在浩瀚宇宙中找到了彼此，一段跨越世俗的唯美爱恋就此展开。',
    tags: ['耽美', '恋爱', '文艺', '唯美'],
    updatedAt: '2026-08-03',
    featured: true,
  },
  {
    id: 11,
    title: '魔女的条件',
    author: '宋慧乔',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20cover%20art%2C%20beautiful%20witch%20with%20magical%20powers%2C%20gothic%20style%2C%20dark%20green%20and%20purple%20tones%2C%20mysterious%20atmosphere%2C%20illustration%20style%2C%20elegant%20composition&width=600&height=840&seq=comic-cover-11&orientation=portrait',
    category: 'fantasy',
    categoryName: '奇幻',
    rating: 9.4,
    views: 1120000,
    chapters: 68,
    status: '连载中',
    description: '在人类与魔女共存的平行世界中，拥有最强魔力的魔女继承人意外与普通人类少年签订了契约。跨越种族的禁忌之恋，伴随着一场改变世界格局的巨大阴谋。',
    tags: ['奇幻', '恋爱', '魔法', '冒险'],
    updatedAt: '2026-08-02',
    featured: false,
  },
  {
    id: 12,
    title: '篮球少年',
    author: '李敏镐',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sports%20cover%20art%2C%20basketball%20player%20dunking%2C%20dynamic%20action%20in%20gym%2C%20bright%20orange%20and%20white%20tones%2C%20energetic%20illustration%20style%2C%20sporty%20composition&width=600&height=840&seq=comic-cover-12&orientation=portrait',
    category: 'action',
    categoryName: '动作',
    rating: 9.0,
    views: 890000,
    chapters: 54,
    status: '连载中',
    description: '身高只有170cm的崔民秀梦想成为职业篮球选手。在所有人都不看好的情况下，他用惊人的速度和精准的投篮证明了自己。一部关于梦想与拼搏的青春热血漫画！',
    tags: ['动作', '体育', '校园', '励志'],
    updatedAt: '2026-08-01',
    featured: false,
  },
];

export const faqs = [
  {
    question: '汗汗漫画需要付费吗？',
    answer: '不需要！汗汗漫画平台上的所有韩国漫画资源完全免费，无需任何付费即可畅享海量正版韩漫。我们致力于为广大漫画爱好者提供优质的免费阅读体验。',
  },
  {
    question: '网站的漫画是否为正版？',
    answer: '是的，汗汗漫画平台上的所有漫画资源均为正版授权。我们与多家韩国知名漫画平台和出版社合作，确保每一位读者都能阅读到高质量的官方正版韩漫。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类导航按题材（恋爱、奇幻、动作、悬疑等）浏览漫画，也可以使用搜索功能直接查找您喜欢的作品。我们还会在首页推荐热门和最新更新的漫画，方便您发现好作品。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '大部分连载中的漫画每周更新一章，具体更新频率视不同作品而定。您可以在漫画详情页查看最近更新时间，热门作品会标注在首页"最新更新"区域。',
  },
  {
    question: '支持手机阅读吗？',
    answer: '当然支持！汗汗漫画采用响应式设计，无论是在电脑、平板还是手机上，都能获得流畅舒适的阅读体验。随时随地，想读就读。',
  },
  {
    question: '如何给喜欢的作品评分？',
    answer: '在每部漫画的详情页，您可以看到当前评分并参与评分。您的每一次评分都将帮助其他读者发现好作品，也会影响漫画在排行榜上的位置。',
  },
];

export const reputationData = [
  {
    id: 1,
    name: '漫画迷小张',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%2C%20casual%20style%2C%20warm%20friendly%20expression%2C%20simple%20white%20background%2C%20clean%20professional%20headshot&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '发现汗汗漫画真的太开心了！终于找到一个完全免费又能看正版韩漫的地方。更新速度超快，画质也很棒，强烈推荐给所有喜欢韩漫的朋友！',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '追漫达人',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20modern%20style%2C%20bright%20smile%2C%20simple%20white%20background%2C%20clean%20professional%20headshot&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '从朋友那里知道了汗汗漫画，一开始还不太相信免费能看这么多正版韩漫。用了快一年了，更新稳定、分类齐全，已经成功安利给了整个宿舍！',
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '深夜读者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20adult%20portrait%2C%20glasses%2C%20intellectual%20style%2C%20gentle%20smile%2C%20simple%20white%20background%2C%20clean%20professional%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '作为一个看了十几年漫画的老读者，汗汗漫画的资源质量和更新速度真的让人惊喜。界面也很干净，阅读体验很舒服，没有烦人的广告弹窗。',
    date: '2026-07-20',
  },
];

export const siteInfo = {
  name: '汗汗漫画',
  tagline: '免费韩国漫画 · 韩漫大全在线阅读',
  description: '汗汗漫画提供免费韩国漫画在线阅读服务，汇集海量韩漫大全，涵盖热门题材，无需付费即可畅享正版韩漫资源。',
  email: 'contact@hanhancomic.com',
  phone: '400-888-0000',
  address: '北京市朝阳区望京SOHO T1 1206室',
  social: {
    weibo: 'https://weibo.com/hanhancomic',
    wechat: 'hanhancomic',
    qq: '123456789',
  },
  stats: {
    totalComics: '10,000+',
    totalReaders: '500万+',
    dailyActive: '50万+',
    rating: '4.9',
  },
};